module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("University Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seeing Things: How Your Imagination Shapes You and Your World")]), _vm._v(", beloved theologian and teacher, Rev. James P.M. Walsh, S.J., shares with us the extraordinary resource of the imagination—how it animates our aspirations, our service, and a deeper connection to God and to one another. Rev. Walsh inspired all those around him to become their very best selves, and his legacy lives on through this book: his insights and reflections invite us into a greater knowledge of ourselves, our faith, and how we find our place in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dr. John J. DeGioia, President of Georgetown University")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Seeing Things: How Your Imagination Shapes You and Your World")]), _vm._v(" is a pedagogical memoir enabling the reader to enter the late Jesuit Professor Rev. James Walsh’s Georgetown University classroom in various moments. Rev. Walsh considered imagination central to lived religion in the broadest sense, namely the vision of the prophet, the exegesis of the theologian, the teaching of the professor, the preaching of the pastor, and the experiences of the student, the seeker and the believer. This book stands as an eloquent and accessible mini-course in the place of imagination in moral theology, as well as the spiritual testament of a caring and loving teacher, healer, and friend.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dr. David Goldfrank, Professor of History, Georgetown University")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("This study is a fascinating presentation of how we imagine ourselves and the context of the world around us. Father Walsh’s longstanding commitment to helping his students and colleagues understand both elevates the text to a unique level of contemplation. He was, in person, always a caring and generous man; in this effort, based on the years of teaching a course on the topic, he reveals fully just how special he was in the classroom and as a writer. This book brought back the reality of someone I always admired and the teaching ministry he pursued during the years I knew him.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dr. Ronald Johnson, Professor Emeritus of History Georgetown University")])]), _vm._v(" "), _c('p', {
    staticClass: "centerimg1"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pgviii.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Rev. James P. M. Walsh, SJ")]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("(Author photo by Lisa Helfert, Georgetown University)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78cd5d3d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/University_Introduction.vue
// module id = 72
// module chunks = 0